import React from "react";

import Slider from "@mui/material/Slider";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import classes from "./style.module.css";
import TickSound from "../../../../../assets/Audio/clickSoundEffect.wav";

const CustomSlider = styled(Slider)({
  color: "rgb(84, 58, 204)",
  height: 20,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "rgb(84, 58, 204)",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

function SingularSlider({ min, max, value, setValue, stepSize }) {
  const theme = createTheme({
    direction: "ltr",
  });
  const TickAudio = new Audio(TickSound);
  const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
  return (
    <div className={classes.sinularSliderContainer}>
      <ThemeProvider theme={theme}>
        <CustomSlider
          valueLabelDisplay="on"
          aria-label="pretto slider"
          value={value}
          onChange={(_, val) => {
            setValue(val);
            if (soudMuted) {
              TickAudio.play();
            }
          }}
          min={min}
          max={max}
          step={stepSize}
        />
      </ThemeProvider>
      <div className={classes.rangeTextContainer}>
        <div>
          <p>{min}</p>
        </div>
        <div>
          <p>{max}</p>
        </div>
      </div>
    </div>
  );
}

export default SingularSlider;
